import {
  Box,
  Button,
  Container,
  Grid,
  IconButton,
  Stack,
  Typography,
  useTheme,
} from '@mui/material'
import ReactPixel from 'react-facebook-pixel'
import ReactGA from 'react-ga4'
import { useNavigate } from 'react-router'
import { Form } from '../../../components/Footer/subComponents/Form'
import {
  FaucetIcon,
  LightningIcon,
  MonitorAndSipp,
  ShieldIcon,
  SippLogo,
  SippLogoWhite,
} from '../../../components/icons'
import { FeatureItem } from './subComponents'

export const Landing = () => {
  const theme = useTheme()
  const navigate = useNavigate()
  return (
    <Grid container maxWidth="xl" sx={{ mx: 'auto' }}>
      <Grid
        id="col1"
        flexDirection="column"
        size={{ xs: 12, md: 6 }}
        sx={{
          p: 4,
          background: 'transparent',
          zIndex: 2,
          position: 'relative',
          overflowX: 'hidden',
          overflowY: 'unset',
        }}
      >
        <MonitorAndSipp
          sx={{
            fontSize: '525px',
            preserveAspectRatio: 'xMidYMid slice',
            position: 'fixed',
            bottom: '-150px',
            zIndex: -1,
            left: { xs: 'unset', md: 'calc(50% - 400px)' },
            right: { xs: '-100px', md: 'unset' },
            opacity: { xs: 0.3, md: 0.9 },
          }}
        />
        <IconButton
          onClick={() => navigate('/')}
          sx={{ '&:hover': { backgroundColor: 'transparent' } }}
        >
          <SippLogo sx={{ fontSize: '4rem' }} />
        </IconButton>
        <Typography variant="h1">What's in Your Water?</Typography>
        <Typography variant="h1">Find out in 60 Seconds.</Typography>
        <Typography variant="body-large" sx={{ mb: 4, width: '100%' }}>
          Just dip the strip, quickly enter the results, and get clear, instant insights about what's
          really in your water.
        </Typography>
        <Button
          variant="contained"
          size="large"
          onClick={() => {
            ReactPixel.trackCustom('click', { id: 'test_your_water', name: 'Test Now' })
            ReactGA.event({
              action: 'click',
              category: 'User event tracking',
              label: 'Test your water',
            })
            navigate('/how-to')
          }}
        >
          Have your strip? Test Now.
        </Button>
      </Grid>
      <Grid id="col2" size={{ xs: 12, md: 6 }} sx={{ zIndex: 2, p: 2 }}>
        <Container maxWidth="md">
          <Form />
        </Container>
      </Grid>
      <Grid id="footer" size={{ xs: 12 }} sx={{ p: 4, zIndex: 2 }} flexDirection="column">
        <Box sx={{ p: 2, backgroundColor: 'blue.700', borderRadius: theme.shape.borderRadius }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              flexGrow: 1,

              gap: 3,
            }}
            flexDirection={{ xs: 'column', md: 'row' }}
          >
            <FeatureItem
              icon={<ShieldIcon sx={{ fontSize: '4rem' }} />}
              title="Understand the risks"
              description="Find out what’s actually in your water and how it affects your health."
            />
            <FeatureItem
              icon={<FaucetIcon sx={{ fontSize: '4rem' }} />}
              title="Go beyond public data"
              description="We test for 16 key contaminants right at your tap."
            />
            <FeatureItem
              icon={<LightningIcon sx={{ fontSize: '4rem' }} color="primary" />}
              title="Instant results"
              description="See clear, accurate insights in seconds right from your phone."
            />
          </Box>
          <Stack spacing={0.5} flexDirection="column" alignItems="center" sx={{ py: 2 }}>
            <SippLogoWhite sx={{ fontSize: '2.5rem' }} />
            <Button
              variant="text-light"
              href="support@sippsafely.com"
              sx={{ textTransform: 'lowercase' }}
            >
              support@sippsafely.com
            </Button>
          </Stack>
        </Box>
      </Grid>
    </Grid>
  )
}
